import React, { useCallback, memo } from 'react'
import {
  Table as BaseTable,
  TableHead,
  TableBody,
  TableFoot,
  TableRow,
  TableHeader,
  TableCell
} from '../ui/Table'
import { useTableSort } from './hooks'
import EmptyState from '../ui/EmptyState'
import VariableCell from './VariableCell'

const formatNumber = value => value.toLocaleString('fr-FR')
const formatPercent = value => `${value.toFixed(1).replace('.', ',')} %`

const NumericTable = ({ statistics, filterUrl, variableId }) => {
  const { totalSum } = statistics || {}

  const getSortValue = useCallback((row, column) => {
    if (column === 'value')
      return (row.value || '').toLowerCase()
    if (column === 'percent')
      return totalSum > 0 ? row.sum / totalSum : 0
    return row.sum
  }, [totalSum])

  const { sortedRows, sortProps } = useTableSort(statistics?.rows, getSortValue)

  if (!statistics?.rows?.length)
    return <EmptyState />

  return (
    <div className="mt-3">
      <BaseTable hover>
        <TableHead>
          <TableRow>
            <TableHeader {...sortProps('value')} className="text-nowrap">
              Variable
            </TableHeader>
            <TableHeader className="text-center" {...sortProps('sum')}>
              Somme
            </TableHeader>
            <TableHeader className="text-center" {...sortProps('percent')}>
              %
            </TableHeader>
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedRows.map((row, index) => {
            const percent = totalSum > 0 ? row.sum / totalSum * 100 : 0
            return (
              <TableRow key={row.value || `empty-${index}`}>
                <VariableCell filterUrl={filterUrl} row={row} variableId={variableId} />
                <TableCell className="text-center">
                  {formatNumber(row.sum)}
                </TableCell>
                <TableCell className="text-center">
                  {formatPercent(percent)}
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
        <TableFoot>
          <TableRow className="bg-light">
            <th>Total</th>
            <th className="text-center">
              {formatNumber(totalSum)}
            </th>
            <th className="text-center">
              100 %
            </th>
          </TableRow>
        </TableFoot>
      </BaseTable>
    </div>
  )
}

export default memo(NumericTable)
